var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Tabbed',{attrs:{"uriRoot":"alerts","names":_vm.names},scopedSlots:_vm._u([{key:"Alerts",fn:function(){return [_c('Alerts')]},proxy:true},{key:"EmailAddresses",fn:function(){return [_c('EmailAddresses')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }